<template>
  <div class="content-430 page-index">
    <BatchRefundSearch :school-id="searchConds.schoolId" @on-search="onSearch"></BatchRefundSearch>
    <BatchRefundCourse
      ref="batchRefundCourseRef"
      v-model="courseList"
      :show-default="showDefault"
      :loading="loading"
    ></BatchRefundCourse>
    <BatchRefundStuList
      ref="batchRefundStuListRef"
      :date-list="dateList"
      :select-detail-id-list="selectDetailIdList"
      :search-data="searchData"
    ></BatchRefundStuList>
    <BatchRefundOther
      ref="batchRefundOtherRef"
      :select-detail-id-list="selectDetailIdList"
      :search-data="searchData"
    ></BatchRefundOther>
    <div class="formbtnbox-430-bottom">
      <Button @click="handleToLastStep">上一步</Button>
      <Button
        type="primary"
        :loading="isSaveing"
        :disabled="isSaveing"
        @click="handleCheckAllForm"
      >保存</Button>
      <Button @click="handleGoBack">取消</Button>
    </div>
    <CheckCodeModal
      ref="checkCodeModalRef"
      check-type="batchRefund"
      modal-title="批量退款申请确认"
      @sendCode="getPhoneCode"
    ></CheckCodeModal>
    <LoadingModal
      ref="loadingModal"
      modal-title="提示"
      modal-content="退款批量申请校验中，请勿关闭当前页面！"
    ></LoadingModal>
    <ResultModal
      ref="resultModal"
      :modal-type="-1"
      :modal-text="resultModalText"
    ></ResultModal>
    <BatchRefundSuccessModal ref="batchRefundSuccessModal"></BatchRefundSuccessModal>
  </div>
</template>

<script>
import BatchRefundSearch from './BatchRefundSearch.vue';
import BatchRefundCourse from './BatchRefundCourse.vue';
import BatchRefundStuList from './BatchRefundStuList.vue';
import CheckCodeModal from './CheckCodeModal.vue';
import BatchRefundSuccessModal from './BatchRefundSuccessModal.vue';
import BatchRefundOther from './BatchRefundOther';
import LoadingModal from './LoadingModal';
import ResultModal from './ResultModal';
import orderCenter from '@/request/orderCenter/index.js';
import { timeToYearStr } from '@/utils/utils.js';
import { mapMutations } from 'vuex';
export default {
  components: {
    BatchRefundSearch,
    BatchRefundCourse,
    BatchRefundStuList,
    BatchRefundOther,
    CheckCodeModal,
    LoadingModal,
    ResultModal,
    BatchRefundSuccessModal
  },
  props: {
    searchConds: {
      type: Object,
      default: () => {
        return {
          schoolId: '',
          termId: ''
        };
      }
    }
  },
  data() {
    return {
      portOrg: Number(localStorage.getItem('portOrg')),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      isSaveing: false,
      courseList: [],
      showDefault: true, // 是否展示展位图
      loading: false,
      searchData: {}, // 搜索参数
      hasSearchParams: false, // 是否有请求参数
      dateList: [],
      resultModalText: '' // 结果弹窗
    };
  },
  computed: {
    selectDetailIdList() {
      if (this.courseList.length === 0) {
        return [];
      }
      const selectList = [];
      this.courseList.forEach(item => {
        item.list.forEach(x => {
          if (x.select) {
            selectList.push({
              classDate: x.classDate,
              detailId: x.detailId,
              classroomName: x.classroomName,
              classroomId: x.classroomId
            });
          }
        });
      });
      return selectList;
    }
  },
  methods: {
    ...mapMutations(['DELETE_CACHEROUTE']),
    // 点击搜索按钮搜索课程列表
    onSearch(data, typeList) {
      console.log(data, typeList);
      this.showDefault = true;
      this.hasSearchParams = false;
      // if (data.classType === '') {
      //   this.$Message.error('请选择课程类别');
      //   return false;
      // }
      if (typeList.length === 0) {
        this.$Message.error('请选择课程类别');
        return false;
      }
      if (data.date === '') {
        this.$Message.error('请选择退款的上课日期');
        return false;
      }
      const dateList = data.date.split(',').map(item => {
        return {
          begin: `${item} 00:00:00`,
          end: `${item} 23:59:59`
        };
      });
      // if (dateList.length > 31) {
      //   this.$Message.error('日期选中不可超过31天');
      //   return false;
      // }
      if (dateList.length > 180) {
        this.$Message.error('日期选中不可超过180天');
        return false;
      }
      this.showDefault = false;
      const paramsData = { ...data, ...this.searchConds };
      const { date, ...params } = paramsData;
      if (typeList.length === 1) {
        params.classType = typeList[0];
      } else if (typeList.length === 3) {
        params.classType = typeList[0];
        params.courseTypeKind = typeList[1];
        params.courseTypeId = typeList[2];
      }
      this.searchData = { ...params };
      console.log(this.searchData, '搜搜参数===');
      params.dateList = dateList;
      this.dateList = dateList;
      this.hasSearchParams = true;
      this.getCourseList(params);
    },
    handleToLastStep() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否回到上一步？回到上一步后当前数据将不会保存</p>',
        onOk: () => {
          this.$emit('toLastStep');
        }
      });
    },
    // 点击取消按钮
    handleGoBack() {
      this.$router.push({
        name: 'orderCenter_afterSale_batchRefundIndex'
      });
    },
    // 点击保存按钮
    handleCheckAllForm() {
      if (!this.hasSearchParams) {
        this.$Message.error('请先查询可以退款的课程商品');
        return false;
      }
      if (this.selectDetailIdList.length === 0) {
        this.$Message.error('请先选择要退款的课程商品');
        return false;
      }
      if (this.$refs.batchRefundOtherRef.reason === '') {
        this.$Message.error('请选择退款原因');
        return false;
      }
      if (this.$refs.batchRefundOtherRef.reason === '其他原因' && this.$refs.batchRefundOtherRef.remark === '') {
        this.$Message.error('请输入退款备注');
        return false;
      }
      this.$refs.checkCodeModalRef.handleOpen();
    },
    // 获取批量退款课程列表
    async getCourseList(params) {
      this.loading = true;
      const res = await orderCenter.getBatchRefundCourseListApi(params);
      if (res.status === 200) {
        this.courseList = [];
        res.message.forEach(item => {
          item.select = true;
          item.classDateShow = timeToYearStr(item.classDate);
          const y = this.courseList.findIndex(x => {
            return x.classDateShow === item.classDateShow;
          });
          if (y === -1) {
            this.courseList.push({
              classDate: item.classDate,
              classDateShow: item.classDateShow,
              list: [item]
            });
          } else {
            this.courseList[y]['list'].push(item);
          }
        });
        // 按日期从小到大排序
        this.courseList.sort((a, b) => {
          return new Date(a.classDate).valueOf() - new Date(b.classDate).valueOf();
        });
        this.loading = false;
      }
    },
    // 打开弹窗
    openModal(type) {
      this.$nextTick(() => {
        this.$refs[type].open();
      });
    },
    // 关闭弹窗
    closeModal(type) {
      this.$nextTick(() => {
        this.$refs[type].close();
      });
    },
    // 获取到手机验证码
    getPhoneCode(code) {
      const detailIdList = this.selectDetailIdList.map(item => {
        return item.detailId;
      });
      // const dateList = this.selectDetailIdList.map(item => {
      //   return item.classDate;
      // });
      const remark = this.$refs.batchRefundOtherRef.reason === '其他原因' ? this.$refs.batchRefundOtherRef.remark : this.$refs.batchRefundOtherRef.reason;
      const params = {
        ...this.searchData,
        detailIdList,
        dateList: this.dateList,
        reason: remark,
        // remark: this.$refs.batchRefundOtherRef.remark,
        checkCode: code
      };
      // this.$refs.checkCodeModalRef.handleClose();
      this.batchRefundOrder(params);
    },
    // 生成批量退款
    async batchRefundOrder(params) {
      this.openModal('loadingModal');
      try {
        const res = await orderCenter.postBatchRefundApi(params);
        this.$refs.checkCodeModalRef.setErrorStr('');
        this.closeModal('loadingModal');
        if (res.status === 200) {
          this.$refs.checkCodeModalRef.handleClose();
          // this.DELETE_CACHEROUTE('orderCenterAfterSaleBatchRefundIndex');
          // this.$router.push({
          //   name: 'orderCenter_afterSale_batchRefundIndex',
          //   query: {
          //     reInit: 1
          //   }
          // });
          this.$refs.batchRefundSuccessModal.openModal(res.message);
        } else if (res.status === 3505 || res.status === 3504) {
          this.$refs.checkCodeModalRef.setErrorStr(res.error);
        } else {
          this.resultModalText = res.error ? res.error : '批量退款申请失败！请刷新后重新发起!';
          this.openModal('resultModal');
        }
      } finally {
        this.closeModal('loadingModal');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-index {
  padding-bottom: 150px !important;
}
</style>
